/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  useMemo, useState, useEffect
} from 'react';
import proptypes from 'prop-types';
const { string: stringType, number: numberType } = proptypes;
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import {
  useDataModel,
  extend
} from '@thd-nucleus/data-sources';
import { useStoreId } from '@thd-nucleus/experience-context';
import { DynamicRecsWrapper } from './DynamicRecsWrapper';

import ZoneCard from '../utils/zone-card';
import { bipProductModel } from '../dataModel';

const DynamicRecsWrapperBipComponent = (props) => {
  const {
    schemaName,
    bundleId,
    hydratorClassName,
    hydratorScrollBuffer,
    hydratorDelay,
    hydratorId: hydratorIdProp,
  } = props;

  const storeId = useStoreId();
  const { data: bipProductData, loading, error } = useDataModel('product', {
    variables: {
      itemId: bundleId,
      storeId
    },
    ssr: false
  });

  const [itemIds, setItemIds] = useState('');

  useEffect(() => {
    if (bipProductData && !loading && !error) {
      const items = bipProductData?.product?.bundleSpecificationDetails?.components?.map((item) => item.defaultProductId);
      setItemIds(items?.join(','));
    }
  }, [bipProductData, loading, error]);

  const hydrator = useMemo(
    () => ({
      tag: ZoneCard,
      ...(hydratorClassName && { className: hydratorClassName }),
      ...(hydratorScrollBuffer && { scrollBuffer: hydratorScrollBuffer }),
      ...(hydratorDelay && { delay: hydratorDelay })
    }),
    [hydratorClassName, hydratorScrollBuffer, hydratorDelay]
  );

  const hydratorId = `recs_${schemaName}`;
  if (itemIds === undefined || itemIds === null || itemIds === '') {
    return null;
  }
  return (
    <DynamicRecsWrapper
      {...props}
      anchorId={itemIds}
      hydrator={{ ...hydrator, id: hydratorIdProp || hydratorId }}
    />
  );
};

const propTypes = {
  schemaName: stringType.isRequired,
  bundleId: stringType.isRequired,
  anchorId: stringType,
  hydratorClassName: stringType,
  hydratorScrollBuffer: numberType,
  hydratorDelay: numberType,
  hydratorId: stringType
};

const defaultProps = {
  anchorId: '',
  hydratorClassName: null,
  hydratorScrollBuffer: null,
  hydratorDelay: null,
  hydratorId: ''
};

DynamicRecsWrapperBipComponent.propTypes = propTypes;
DynamicRecsWrapperBipComponent.defaultProps = defaultProps;
DynamicRecsWrapperBipComponent.displayName = 'DynamicRecsWrapperBipComponent';
DynamicRecsWrapperBipComponent.dataModel = extend(
  bipProductModel,
  DynamicRecsWrapper
);

export const DynamicRecsWrapperBip = withErrorBoundary(DynamicRecsWrapperBipComponent);

DynamicRecsWrapperBip.dataModel = extend(
  bipProductModel,
  DynamicRecsWrapper
);
DynamicRecsWrapperBip.displayName = 'DynamicRecsWrapperBip';
DynamicRecsWrapperBip.propTypes = propTypes;
DynamicRecsWrapperBip.defaultProps = defaultProps;